const SELECTRORS = {
  swiperContainer: '.featured-collection-slider-modal__meta-controls',
};
/**
 * Initialize swiper
 *
 * @param {object} Swiper swiper class object
 */
const initCategorySlider = (Swiper) => {
  const swiperContainer = document.querySelector(SELECTRORS.swiperContainer);
  const swiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 0,
    watchOverflow: true,
    loop: false,
    allowSlideNext: true,
    allowSlidePrev: true,
    breakpoints: {
      660: {
        allowSlideNext: false,
        allowSlidePrev: false,
      },
    },
  };

  if (swiperContainer) {
    // eslint-disable-next-line no-unused-vars
    const categorySwiper = new Swiper(swiperContainer, swiperOptions);
  }
};
document.addEventListener('DOMContentLoaded', () => {
  window.LoadSwiper.then((module) => {
    initCategorySlider(module.Swiper);
  });
  const close = document.querySelector('.quick-recommendation__quit');
  const modal = document.querySelector('.quick-recommendation__wrapper');
  const button = document.querySelector('.quick-recommendation-btn');
  const mobileBtn = document.querySelector('.quick-recommendation-btn--mobile');
  const recommendation_scroll = document.querySelector("body");
  close.addEventListener('click', () => {
    modal.classList.add('hidden');
    recommendation_scroll.classList.remove("scroll_none");
  });

  if (button) {
    button.addEventListener('click', () => {
      modal.classList.remove('hidden');
      recommendation_scroll.classList.add("scroll_none");
    });
  }

  if (mobileBtn) {
    mobileBtn.addEventListener('click', () => {
      modal.classList.remove('hidden');
    });
  }
});
